export default __webpack_public_path__ + "media/images/testimonials/hands-9844fff9d37341a9ae1bc3ea50ce7204.svg";